import React,{ Component } from 'react';
import Link from 'react-router-dom/NavLink';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import VerifiedPurchasesList from "../../VerifiedPurchasesList";
import PromotionList from "../../PromotionList";

class ProviderPromotions extends Component {
  constructor(props){
    super(props);

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    //TODO: Load data from server for ProviderConfiguration in componentDidMount
    Promise
      .all([])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  componentWillUnmount(){
    //TODO: Cleanup after ProviderConfiguration in componentWillUnmount
  }

  render(){
    const { match } = this.props

    return (
      <Container>
        <Row>
          <Col xs='6'>
            <br />
            <h6>Internal use only!</h6>
            <h3>Promotions</h3>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                    tag={Link}
                    to={`${match.url}/verifiedpurchases`}
                    activeClassName='active'
                >
                  &nbsp;&nbsp;Verified Purchases
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                    tag={Link}
                    to={`${match.url}/promotions`}
                    activeClassName='active'
                >
                  &nbsp;&nbsp;Deals and Discounts
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <br />
        <Switch>
          <Route path={`${match.url}/verifiedpurchases`} component={VerifiedPurchasesList} />
          <Route path={`${match.url}/promotions`} component={PromotionList} />
        </Switch>
      </Container>
    );
  }
}

export default ProviderPromotions;



// WEBPACK FOOTER //
// ./src/routes/ProviderPromotions/components/ProviderPromotions.js